import Vue, { ComponentOptions, PluginObject } from 'vue';
import { createDecorator } from 'vue-class-component';
import { Container, interfaces } from 'inversify';

const containerKey = '__inversify_container__';

export class InjectionsProvider implements PluginObject<any> {
    constructor(private _container: Container) { }

    public install() {
        const container = this._container;

        Vue.mixin({
            beforeCreate() {
                const options = this.$options as any;
                const _this = this as any;
                if (options[containerKey]) {
                    _this[containerKey] = options[containerKey];
                } else if (options.parent && options.parent[containerKey]) {
                    _this[containerKey] = options.parent[containerKey];
                } else {
                    _this[containerKey] = container;
                }
            },
        });
    }
}

export const Inject = (identifier?: interfaces.ServiceIdentifier<any>) => (proto: Vue, key: string) => {
    let Type: any;

    if (typeof Reflect !== 'undefined' && typeof Reflect.getMetadata === 'function') {
        Type = Reflect.getMetadata('design:type', proto, key);
    }

    return createDecorator((options: ComponentOptions<Vue>, name) => {
        options.computed = options.computed || {};
        options.computed[name] = function() {
            const _this = this as any;
            return (_this[containerKey] as Container).get(identifier || Type);
        };
    })(proto, key);
};
